export enum ClosenessToExpiration {
    NOT_APPLICABLE = "NOT_APPLICABLE",
    LESS_THAN_2_DAYS_OR_EXPIRED = "LESS_THAN_2_DAYS_OR_EXPIRED",
    LESS_THAN_7_DAYS = "LESS_THAN_7_DAYS"
}